import { GET_DOMAINS_SUCCESS } from './domain.types';

const initialState = {
    domainList: [],
};

export const domainReducer = (state = initialState, action) => {
    switch (action.type) {
        /** Domain */
        case GET_DOMAINS_SUCCESS:
            return {
                ...state,
                domainList: action.payload,
            };
        /** End */

        default:
            return state;
    }
};
